import { useEffect } from "react";

const useMPSsecurity = (mercadoPagoKey) => {
  useEffect(() => {
    const isAutoatendimento =
      window.location.pathname.includes("autoatendimento");
    if (!mercadoPagoKey || isAutoatendimento) {
      return;
    }

    const script2 = document.createElement("script");
    script2.type = "text/javascript";
    script2.async = false;
    script2.innerHTML = `window.mercadoPago = new MercadoPago('${mercadoPagoKey}');`;

    let timer = null;
    const script1 = document.createElement("script");
    script1.src = "https://sdk.mercadopago.com/js/v2";
    script1.async = false;
    script1.addEventListener("load", () => {
      timer = setTimeout(() => document.body.appendChild(script2), 2000);
    });

    document.body.appendChild(script1);

    return () => {
      // O script2 só entra no DOM 2s depois do load do script1. A limpeza
      // antiga chamava removeChild nele de qualquer jeito e estourava
      // NotFoundError se o usuário saísse da tela antes disso — o que já
      // acontecia sem StrictMode nenhum. `remove()` é no-op quando o nó não
      // está montado, e o timer precisa ser cancelado para não injetar o
      // script depois que o efeito já morreu.
      clearTimeout(timer);
      script1.remove();
      script2.remove();
    };
  }, [mercadoPagoKey]);
};

export default useMPSsecurity;
